import { useRef, useEffect } from 'react';
import keyboard from 'keymaster';

export type KeyHandlers = Record<string, (e: KeyboardEvent) => void>;

let counter = -1;

keyboard.filter = e => {
  // keymaster types `e` as a FilterEvent, which has no `which`.
  if ((e as unknown as KeyboardEvent).which === 27) {
    return true;
  }
  // Reads the global `event`, not `e`: the behavior from before the conversion.
  const current = event as Event;
  const tagName = ((current.target || current.srcElement) as Element).tagName;
  return !(tagName == 'INPUT' || tagName == 'SELECT' || tagName == 'TEXTAREA');
};

export default (name = 'keys', active = false, keyDef: KeyHandlers = {}) => {
  const guid = useRef<string | null>(null);
  const keys = useRef(keyDef);
  useEffect(() => {
    counter += 1;
    guid.current = `${name}-${counter}`;

    return function cleanup() {
      counter -= 1;
    };
  }, [name]);

  useEffect(() => {
    if (guid.current !== null) {
      Object.keys(keys.current).forEach(key => {
        keyboard(`${key}`, guid.current as string, keys.current[key]);
      });
    }

    return function cleanup() {
      keyboard.deleteScope(guid.current as string);
    };
  }, [guid, keys]);

  useEffect(() => {
    if (active) {
      keyboard.setScope(guid.current as string);
    } else {
      if (keyboard.getScope() === guid.current) {
        keyboard.setScope('all');
      }
    }
  }, [active, guid]);
};
